<template lang="pug">
  .bulk-setting-item
    v-row(no-gutters align="center")
      v-col(cols="9")
        v-card(flat)
          v-row.my-2(no-gutters)
            v-col.py-1.shrink.mr-3
              v-img(:src="parentBundle.image ? parentBundle.image.file : require('@/assets/image_placeholder.png')" width="56px" aspect-ratio="1")
            v-col.py-3
              div.p1.basic800--text.mb-1 {{ parentBundle.name }}
              div.c2.basic600--text.product-description.mb-1 {{ parentBundle.bundle.slots.length }} {{ parentBundle.bundle.slots.length > 1 ? 'items' : 'item' }}
      v-col.ml-auto(:cols="$vuetify.breakpoint.xs ? 3 : 2")
        v-form(ref="form")
          v-text-field.centered-input(v-model.number="value" v-if="selectedSetting === 'price'" hide-details="auto" dense outlined height="40" background-color="basic200" :prefix="$currency.symbol" type="number" :rules="rules.has_quantity" :class="valueChanged || focused ? 'value-changed' : ''")
          v-text-field.centered-input(v-model.number="value" v-if="selectedSetting === 'weight'" hide-details="auto" dense outlined height="40" background-color="basic200" suffix="kg" type="number" :rules="rules.weight" :class="valueChanged || focused ? 'value-changed' : ''")
          v-text-field.centered-input(v-model.number="value" v-if="selectedSetting === 'inventory'" hide-details="auto" dense outlined height="40" background-color="basic200" type="number" :rules="rules.number_not_empty" :class="valueChanged || focused ? 'value-changed' : ''")

    v-divider.basic300
</template>

<script>
export default {
  name: 'BundleBulkIndividualItem',
  props: {
    focused: {
      type: Boolean
    },
    parentBundle: {
      type: Object,
      required: true
    },
    selectedSetting: {
      type: String,
      required: true
    },
    edited: {
      type: Object,
      default: null
    }
  },
  data(v) {
    return {
      value: v.getValue(v.parentBundle),
      rules: {
        number_not_empty: [v => v !== null || 'This field is required', v => v !== '' || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v > 0 || 'Price should be more than'],
        weight: [v => v !== null || 'This field is required', v => v !== '' || 'This field is required', v => v >= 0 || 'Weight should be positive', v => v <= 60 || 'Weight should not be above 60 KG']
      },
      valueChanged: false
    }
  },
  mounted() {
    if (this.edited) {
      this.value = this.edited.value
    }
  },
  watch: {
    value: {
      immediate: false,
      handler(val) {
        if (!this.$refs.form.validate()) {
          this.$emit('removeValue', { id: this.parentBundle.id })
          this.valueChanged = false
          return
        }
        switch (this.selectedSetting) {
          case 'price':
            if (val !== this.parentBundle.price / this.$currency.multiplier) {
              this.$emit('editValue', { id: this.parentBundle.id, value: val })
              this.valueChanged = true
            } else {
              this.$emit('removeValue', { id: this.parentBundle.id })
              this.valueChanged = false
            }
            break

          case 'weight':
            if (val !== this.parentBundle.weight) {
              this.$emit('editValue', { id: this.parentBundle.id, value: val })
              this.valueChanged = true
            } else {
              this.$emit('removeValue', { id: this.parentBundle.id })
              this.valueChanged = false
            }
            break

          case 'inventory':
            if (val !== this.parentBundle.inventory_qty) {
              this.$emit('editValue', { id: this.parentBundle.id, value: val })
              this.valueChanged = true
            } else {
              this.$emit('removeValue', { id: this.parentBundle.id })
              this.valueChanged = false
            }
            break

          default:
            break
        }
      }
    }
  },
  methods: {
    getValue(parentBundle) {
      switch (this.selectedSetting) {
        case 'price':
          return parentBundle.price / this.$currency.multiplier

        case 'weight':
          return parentBundle.weight

        case 'inventory':
          return parentBundle.inventory_qty

        default:
          return null
      }
    }
  }
}
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.value-changed {
  border: 1px solid var(--v-success500);
}
</style>